import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    this.element.addEventListener('keydown', this.validateKey)
  }

  disconnect() {
    this.element.removeEventListener('keydown', this.validateKey)
  }

  validateKey = (event) => {
    const allowedKeys = [
      'Backspace',
      'Enter',
      'Delete',
      'ArrowLeft',
      'ArrowRight',
      'Tab'
    ]

    if (!/^[0-9]$/.test(event.key) && !allowedKeys.includes(event.key)) {
      event.preventDefault()
    }
  }
}